import { borderColor, color } from "@mui/system";
import { theme } from "../themes/GeneralTheme";

export const outlinedInput = {
  height: 68,
  padding: 5,
  borderRadius: 4,
  border: `3px solid`,
  borderColor: theme.palette.secondary.light,
  transiton: "all 2s ease-in-out",

  "&.Mui-disabled input": {
    color: theme.palette.secondary.light,
    WebkitTextFillColor: theme.palette.secondary.light,
    pl: 0,
  },
  ".MuiInputAdornment-root p": {
    color: theme.palette.secondary.light,
  },
  "&.Mui-error": {
    border: `3px solid ${theme.palette.error.main}`,
  },
};

export const modalClasses = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 680,
  width: "100%",
  bgcolor: theme.palette.primary.main,
  boxShadow: 24,
  p: theme.spacing(8, 7),
  borderRadius: theme.spacing(6),
  [theme.breakpoints.down("md")]: {
    maxWidth: "90%",
    borderRadius: theme.spacing(6),
    p: theme.spacing(5),
  },
};

export const boxClasses = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 100,
  display: "flex",
  flexDirection: "column",
  width: "569px",
  padding: "30px",
  borderRadius:  theme.spacing(5),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
};

export const maskClasses = {
  "&::after": {
    content: "''",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    borderRadius: theme.spacing(5),
    backgroundColor: "rgba(0, 0, 0, 0.40)",
    zIndex: 1,
  },
};
